import humps from 'humps';
import {
  QueryKey,
  useQuery as _useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import Cookies from 'js-cookie';

import COOKIES_KEY from 'constants/cookies';
import { CustomError, fetcherQuery } from '@utils/react-query';

const useQuery = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<
    TQueryFnData,
    CustomError<TError>,
    TData,
    TQueryKey
  > = {},
) => {
  const { queryFn, meta, ...resOptions } = options;

  return _useQuery<TQueryFnData, CustomError<TError>, TData, TQueryKey>({
    queryFn: async (context) => {
      const result = await (queryFn ? queryFn(context) : fetcherQuery(context));
      return humps.camelizeKeys(result) as TQueryFnData;
    },
    meta: {
      ...meta,
      token: Cookies.get(COOKIES_KEY.TOKEN),
    },
    ...resOptions,
  });
};

export default useQuery;
